export interface IPaymentReminderConfigForm {
  whatsapp_campaign_automation_configuration_uuid: string;
  configuration_name: string;
  configuration_description: string;
  whatsapp_template_uuid: string;
  template_name: string;
  header_media: { type: string; value: string }[];
  button_variable_column_name: {
    type: string;
    value: string;
    sub_type: string;
  }[];
  module_variables_columns_name: {
    type: string;
    value: string;
  }[];
  market_campaign_rule_template_uuid: string;
  market_campaign_rule_template_name: string;
  campaign_rule: {
    event_type: string[];
    status: string[];
    duration_type: "BEFORE" | "AFTER" | "";
    number_count: number;
    duration: "DAYS" | "WEEKS" | "MONTHS" | "";
  };
  campaign_sql_rule: string;
  company_outlet_uuid: string;
  cron_scheduler: {
    second: string;
    minute: string;
    hour: string;
    day: string;
    month: string;
    weekday: string;
    repeatEvery: boolean;
  };
  status: "ACTIVE" | "INACTIVE";
  /** mapping_keys from the selected rule template — used as column options in body variable "Select" type */
  mapping_keys?: Record<string, string>;
}

export const initialPaymentReminderConfigForm: IPaymentReminderConfigForm = {
  whatsapp_campaign_automation_configuration_uuid: "",
  configuration_name: "",
  configuration_description: "",
  whatsapp_template_uuid: "",
  template_name: "",
  header_media: [],
  button_variable_column_name: [],
  module_variables_columns_name: [],
  market_campaign_rule_template_uuid: "",
  market_campaign_rule_template_name: "",
  campaign_rule: {
    event_type: [],
    status: [],
    duration_type: "",
    number_count: 1,
    duration: "DAYS",
  },
  campaign_sql_rule: "",
  company_outlet_uuid: "",
  cron_scheduler: {
    second: "0",
    minute: "*",
    hour: "*",
    day: "*",
    month: "*",
    weekday: "*",
    repeatEvery: false,
  },
  status: "ACTIVE",
};
